import { render, staticRenderFns } from "./ReprovarClassificacao.vue?vue&type=template&id=f17809fa"
import script from "./ReprovarClassificacao.vue?vue&type=script&lang=js"
export * from "./ReprovarClassificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports